import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";
import { showSuccessNotification } from "@utils/showNotification";

import { immunizationQKeys } from "@hooks/queries/immunization/queryKeys";
import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";


interface MutationProps {
  immunizationId: string;
  fileName: string;
  patientId: string;
}

export const useDeleteImmunizationFile = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: ({ immunizationId, fileName }: MutationProps) => {
      return api.delete(`preventative/${immunizationId}/file/${fileName}`);
    },

    onSuccess: (res, variables) => {
      showSuccessNotification({
        title: "success",
        message: "delete-immunization-file-success",
      });
      // If there are no more files, invalidate the query
      if (!res.data.count) {
        queryClient.invalidateQueries({
          queryKey: immunizationQKeys.patient(variables.patientId),
        });
      }
    },

    onError: (res: any) => {
      console.error("[From Delete Immunization File]", res);

      handleErrors(res, "mutation");
    },
  });
};
